angular
    .module("skillBuilderSaaS")
    .filter("sbHtmlToPlainText2", function () {
    return function (html) {
        var temp = document.createElement("div");
        temp.innerHTML = html;
        return temp.textContent || temp.innerText || "";
    };
});
